import { osnovaApi } from '../base';
import type { DiskInfo } from '@entities/disk/types';

/**
 * Состояние ОСНОВА.Диска — единственная ручка Диска в общем бандле: по ней
 * боковое меню решает, показывать ли пункт «Диск». Остальные ручки — в
 * `endpoints/disk.ts`, их грузит только окно Диска (отдельный чанк).
 *
 * 404 (сервер без Диска) или ошибка — пункта нет.
 */
export const diskInfoApi = osnovaApi.injectEndpoints({
  endpoints: (b) => ({
    getDiskInfo: b.query<DiskInfo, void>({
      query: () => '/disk/info',
      providesTags: [{ type: 'Disk', id: 'INFO' }],
      // Включение Диска — редкое событие: держим ответ, пока открыта вкладка.
      keepUnusedDataFor: 1800,
    }),
  }),
  overrideExisting: false,
});

export const { useGetDiskInfoQuery } = diskInfoApi;
